import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export class RetailerPaymentService {
  getRetailerOrderPayments(paymentId, trashed) {
    return RetailerApiClient.get(`retailer-payments/${paymentId}/order-payments`, {
      params: {
        trashed: trashed
      }
    })
  }
}
